module.exports = __webpack_public_path__ + "assets/telemedicinaagora-ico-pickdate.77572119.svg";